import React from 'react'
import { useToast } from '../../contexts/ToastContext'
import { Toast } from './Toast'

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToast()

  if (toasts.length === 0) {
    return null
  }

  return (
    <div
      className="fixed top-4 right-4 z-[100] pointer-events-none"
      aria-live="polite"
      aria-atomic="false"
    >
      <div className="flex flex-col items-end pointer-events-auto">
        {toasts.map((toast) => (
          <Toast key={toast.id} toast={toast} onClose={removeToast} />
        ))}
      </div>
    </div>
  )
}
